// Template for step-by-step dropin on Q-size stage (2388x1080)

import AnimateProxyBase from "SATPROF_LIBRARY/DropinSupervisor/animate-proxys/animate-proxy-base";
import AnimateRenderSpace from "SATPROF_LIBRARY/DropinSupervisor/render-spaces/animate-render-space";
import DropinSupervisorBase from "SATPROF_LIBRARY/DropinSupervisor/dropin-supervisor-base";
import AnimateButtonProxy from "SATPROF_LIBRARY/DropinSupervisor/animate-proxys/animate-button-proxy";
// Comment out any of the following you don't need, to minimize dropin size.
import TimingInfo from 'SATPROF_LIBRARY/DropinSupervisor/timing-info';
import UtilSP from "SATPROF_UTILS/UtilSP"; 
import ThreeFontService from "SATPROF_LIBRARY/DropinSupervisor/services/three-font-service"; // Needed for 3D text
import UniversalRenderSpace from "SATPROF_LIBRARY/DropinSupervisor/render-spaces/universal-render-space"; // For 3D:
// Add any more imports for proxies, etc here:
import AntennaPatternFourierSimulator_p from "SATPROF_LIBRARY/AntennaPatternFourierSimulator/AntennaPatternFourierSimulator_p"
import Complex from "SATPROF_UTILS/Complex"; 
import * as THREE from 'three';


//--------------------------------------------------------------

class ExtendedDropin extends DropinSupervisorBase {

    private animateSpace: AnimateRenderSpace;
    private mystage:any;
    private _dropinName:string = "Ant83Q"; // Mandatory - must match dropin and folder name
    private _type:string = "?"; // W = widget, Z = zip
    public universal_rs : UniversalRenderSpace;
    public myTimer:TimingInfo;
    //----------------------------------------------------
    // Declare any vars here
    public universal_rs2 : UniversalRenderSpace;
    public universal_rs1 : UniversalRenderSpace;    
    public patternSim_p:AntennaPatternFourierSimulator_p;
    //private slider2_p:Slider_p;    
    //----------------------------------------------------
    // this is called before onFrameZero as a specific place for registering services.
    // this is necessary because services can make onFrameZero wait while they load things (by design)
    initServices() {
        this.registerService(new ThreeFontService()); // Needed for 3D text anywhere in the whole dropin.
    }
    onFrameZero() {
        super.onFrameZero();

        // add the animate renderspace
        this.animateSpace = new AnimateRenderSpace();
        this.addRenderSpace(this.animateSpace);
        this.animateSpace.setBounds(0,0,1,1);
        this.mystage =  this.animateSpace.exportRootProxy.stageSymbol;

        if (this.isWidget()){
            this._type = "W";
        } else {
            this._type = "Z";
        }
        this.currentStep = 0;
        
        const prev_btn_p = this.animateSpace.exportRootProxy.getProxy("prev_btn", AnimateButtonProxy);
        const next_btn_p = this.animateSpace.exportRootProxy.getProxy("next_btn", AnimateButtonProxy);
        const replay_btn_p = this.animateSpace.exportRootProxy.getProxy("replay_btn", AnimateButtonProxy);
        this.updateStatusText();

        next_btn_p.onPress((e) => {
            if (this.currentStep <this.lastStep){
                this.playStep(this.currentStep+1)
            }
        });

        prev_btn_p.onPress((e) => {
             if (this.currentStep > 0){
                this.playStep(this.currentStep-1)
            }
        });
        replay_btn_p.onPress((e) => {
               this.playStep(this.currentStep)
        });

        this.onChangeStep((requestedStep, currentStep) =>{
            // Handle the calls coming from the Cp nav buttons.
            console.log("In "+this.dropinName+" main.ts,  onChangeStep, requestedStep = "+requestedStep+", currentStep = "+currentStep);
            // logic for whether or not to proceed
            if(requestedStep > this.lastStep){
                return true; // Can't proceed
            } else if(requestedStep <0 ) {
                return true; // Can't proceed
            } else {
                this.playStep(requestedStep)
            }
            return false; // Tell Cp button not to go to another slide
        })
        this.initialize();
        this.updateStatusText();
        console.log("In "+this._dropinName+" main.ts, onFrameZero... ")
        console.log("isWidget = "+this.isWidget());        
    }
    private updateStatusText(){
        this.mystage.status_txt.text = this._dropinName + " ("+this._type+"), step "+this.currentStep+"/"+this.lastStep;
    }
    public onRequestAnimFrame(timingInfo : TimingInfo) {
        //console.log('in onRequestAnimFrame');
        this.doEveryFrame();
    }  
    public set dropinName(name:string){
        this._dropinName = name;
    }
    public get dropinName(){
        return this._dropinName;
    }
    private initialize(){
        //----------------------------------------------------
        //Uncomment this block if you are using any 3D:
        /*
        // add the 3js renderspace
        this.universal_rs = new UniversalRenderSpace();
        this.addRenderSpace(this.universal_rs);
        this.universal_rs.setBoundsBaseObject(this.animateSpace.getCanvas());
        
        // Settings for superwide template:
        let anStageWidth:number = 2388; // Stage width (animateSpace)
        let anStageHt:number = 1080; // Stage height
        let can3x:number = 950; //  Upper left corner of universal_rs
        let can3y:number = 50; // Upper left corner of universal_rs (0 is at top)
        let can3w:number = 1400; // Width of universal_rs
        let can3h:number = 900; //Height of universal_rs  

        let can3LLx:number = can3x; // Lower left corner of universal_rs
        let can3LLy:number = can3y + can3h; // Lower left corner of universal_rs (0 is at top)    
        this.universal_rs.setBounds(can3LLx/anStageWidth, (can3LLy-can3h)/anStageHt, 
            can3w/anStageWidth, can3h/anStageHt);
        this.universal_rs.uniCamHandler.pixelSnap = 0.2; // Gives 0.2 deg snap res
        this.universal_rs.uniCamHandler.distance = 150000;
        this.animateSpace.passEventsTo(this.universal_rs);
        this.universal_rs.setZIndex(-1); // Put the 3JS canvas at the back
        */
        //----------------------------------------------------
        // Edit init stuff here
        this.lastStep = 5;  // Mandatory
        this.mystage.replay_btn.visible = false; // Optional
        this.myTimer = new TimingInfo();  // A handy timer in case you need it
        this.myTimer.reset();
        //this.myTimer.elapsedTime

        // Add more init stuff here:
        this.universal_rs1 = new UniversalRenderSpace(undefined,{logarithmicDepthBuffer:true, antialias:true });
        this.addRenderSpace(this.universal_rs1);

        this.universal_rs2 = new UniversalRenderSpace(undefined,{logarithmicDepthBuffer:true, antialias:true });
        this.addRenderSpace(this.universal_rs2);

        this.universal_rs1.getCanvas().style.display="none"; // "block" Reveals the whole renderspace, "none" Hides the whole renderspace
        this.universal_rs2.getCanvas().style.display="block";
        this.universal_rs2.uniCamHandler.pos = new THREE.Vector3(0,5000,0);

        this.patternSim_p = this.animateSpace.exportRootProxy.getProxy(
        "patternSim",  // stage symbol instance name (display tree path relative to current)
        AntennaPatternFourierSimulator_p,   // Class of the proxy to be created
        {animateSpace:this.animateSpace, universal_rs1:this.universal_rs1, universal_rs2:this.universal_rs2});
        
        this.patternSim_p.layout = "Invisible";
        this.patternSim_p.apertureShape = "Circular";
        this.patternSim_p.apertureWidth = 242;
        this.patternSim_p.taperType = "Gaussian";
        this.patternSim_p.AFD_GaussianTaper = 1008;
    
        this.mystage.camSummary_txt.visible = false;
        this.universal_rs2.uniCamHandler.snapTo(63, -45, 66);
        //----------------------------------------------------
        this.playStep(0);
    }

    private playStep(step:number){
        //-------------------------------------------------------------------------------------
        // Put code here that runs when each step is entered.
        this.currentStep = step;
        this.updateStatusText();  //  Requires status_txt to be in the stage
        this.animateSpace.exportRoot.gotoAndPlay("Step"+step);  // Controls the playhead
        if (this.isWidget()){
            this.mystage.next_btn.visible = false;
            this.mystage.prev_btn.visible = false;
            this.mystage.replay_btn.visible = false;  
        } else {
            this.mystage.next_btn.visible = (this.currentStep < this.lastStep);
            this.mystage.prev_btn.visible = (this.currentStep > 0);
        } 
        //----------------------------------------------------
        // Do step stuff here

        switch (this.currentStep) {
            case 0:
                this.reset();
                this.patternSim_p.layout = "Pattern only";
                this.universal_rs2.uniCamHandler.enableMouseAndWheel = false;
                this.universal_rs2.uniCamHandler.snapTo(63, -45, 66);
                break;
            case 1:
                this.reset();
                this.patternSim_p.layout = "Pattern only";
                this.universal_rs2.uniCamHandler.enableMouseAndWheel = false;
                this.universal_rs2.uniCamHandler.distance = 66;
                this.universal_rs2.uniCamHandler.pan = 90;
                this.universal_rs2.uniCamHandler.tilt = -90;
                this.patternSim_p.lookatY = 0; 
                break;
            case 2:
                this.reset();
                this.patternSim_p.layout = "Pattern only";
                this.universal_rs2.uniCamHandler.enableMouseAndWheel = true;
                this.universal_rs2.uniCamHandler.distance = 66;
                this.universal_rs2.uniCamHandler.pan = 100;
                this.universal_rs2.uniCamHandler.tilt = -60;
                this.patternSim_p.lookatY = 0;  
                break;
            case 3:
                this.reset();
                this.patternSim_p.layout = "Pattern and cut";
                this.universal_rs2.uniCamHandler.enableMouseAndWheel = true;
                this.universal_rs2.uniCamHandler.distance = 66;
                this.universal_rs2.uniCamHandler.pan = 90+26;
                this.universal_rs2.uniCamHandler.tilt = -60;                
                //this.universal_rs2.uniCamHandler.snapTo(90+26, -60, 66);
                this.patternSim_p.showCut = true;           
                break;
            case 4:
                this.reset();
                this.patternSim_p.layout = "Pattern and cut";
                this.universal_rs2.uniCamHandler.enableMouseAndWheel = true;
                this.universal_rs2.uniCamHandler.distance = 66;
                this.universal_rs2.uniCamHandler.pan = 90+26;
                this.universal_rs2.uniCamHandler.tilt = -60;                
                this.patternSim_p.showCut = true;           
                break;
            case 5:
                this.reset();
                this.patternSim_p.layout = "Pattern and cut";
                this.universal_rs2.uniCamHandler.enableMouseAndWheel = true;
                this.universal_rs2.uniCamHandler.distance = 66;
                this.universal_rs2.uniCamHandler.pan = 90+26;
                this.universal_rs2.uniCamHandler.tilt = -60;                
                this.patternSim_p.showCut = true;           
                break;
            case 6:
                this.reset();
                break;                
            default:
                this.reset();
                break;
        }
    }
    private reset(){
        console.log("In reset.");
       //----------------------------------------------------
        // Do step reset stuff here
        // this.universal_rs2.uniCamHandler.distance = 66;
        // this.universal_rs2.uniCamHandler.pan = 63;
        // this.universal_rs2.uniCamHandler.tilt = -45;
        this.patternSim_p.lookatY = 0;
        this.patternSim_p.cutTheta = 0;           
        this.patternSim_p.showCut = false;           
        //----------------------------------------------------
    }
    private doEveryFrame(){
        //console.log("In doEveryFrame.");
        //----------------------------------------------------
        // Do every frame stuff here.
        //console.log("cam dist = "+this.universal_rs2.uniCamHandler.distance);
       // console.log("cam dist = "+this.universal_rs2.uniCamHandler.distance +", pan = "+ this.universal_rs2.uniCamHandler.pan + 
       //     ", tilt = "+this.universal_rs2.uniCamHandler.tilt);
        //this.universal_rs2.uniCamHandler.consoleLogShortSummary = true;
        this.mystage.camSummary_txt.text = this.universal_rs2.uniCamHandler.positionSummary;
        //----------------------------------------------------       
    }
    private onDialChange(evt:any){
    }


}


export default ExtendedDropin;